import React, { useState } from 'react'
import { deleteTask, removeFromSharedTask } from '../utils/supabase'
import { useAuth } from '../hooks/useAuth'

const DeleteModal = ({ task, onDelete, onClose }) => {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const isTaskCreator = task.user_id === user?.id

  const handleDelete = async () => {
    setLoading(true)
    setError('')
    
    try {
      if (isTaskCreator) {
        // Creator deletes entire task (removes for everyone)
        const { error } = await deleteTask(task.id)
        if (error) throw error
      } else {
        // Shared user removes themselves from the task
        const { error } = await removeFromSharedTask(task.id, user.email)
        if (error) throw error
      }
      
      onDelete(task.id)
    } catch (error) {
      console.error('Error:', error)
      const action = isTaskCreator ? 'delete task' : 'remove from shared tasks'
      setError(`Failed to ${action}: ` + error.message)
      setLoading(false)
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{isTaskCreator ? 'Delete Task' : 'Remove From Task'}</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <div className="delete-content">
          {isTaskCreator ? (
            <>
              <p>Are you sure you want to delete this task?</p>
              <div className="task-preview">
                <strong>{task.title}</strong>
                {task.description && <p>{task.description}</p>}
              </div>
              <p className="warning-text">
                This will remove the task for everyone, including all shared users. 
                All subtasks and sharing will also be removed.
              </p>
            </>
          ) : (
            <>
              <p>Remove this shared task from your task list?</p>
              <div className="task-preview">
                <strong>{task.title}</strong>
                {task.description && <p>{task.description}</p>}
              </div>
              <p>
                The task will remain for the creator and other shared users. 
                The creator can share it with you again if needed.
              </p>
            </>
          )}
        </div>
        
        <div className="modal-actions">
          <button
            onClick={onClose}
            disabled={loading}
            className="btn"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className="btn btn-danger"
          >
            {loading 
              ? (isTaskCreator ? 'Deleting...' : 'Removing...') 
              : (isTaskCreator ? 'Delete Task' : 'Remove Me From Task')
            }
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal